<template>
<div style="min-height: 100%;">
  <HeaderView></HeaderView>
  <NavigateView></NavigateView>
  <BannerView></BannerView>
  <div v-bind:style="{minHeight: height+'px'}" style="width: 1000px;margin: 0 auto;">
    <el-tabs v-model="active">
      <el-tab-pane name='0'>
        <template #label>
          <span><i class="el-icon-user-solid"></i>账户信息</span>
        </template>
        <template>
          <el-alert v-if="!companyInfo.activation && companyInfo.error" type="error" :closable="false" class="account-title"
            title="资质审核未通过说明"
            :description="companyInfo.error"
            show-icon>
          </el-alert>
        </template>
        <template>
          <el-alert :visible.sync="companyInfo.username" type="info" :closable="false" class="account-title">
            <p>{{`欢迎您 ` + companyInfo.username + ` ,`}}</p>
            <p>&emsp;您在本网站填写的联系方式如下，</p>
            <p>
              &emsp;联系电话：
              <el-badge value="修改" type="primary" :hidden="true">
                <el-button size="" style="border: 0; background-color: transparent; padding: 0px 8px 14px 0;">
                  <template v-if="11 === companyInfo.phone.length">
                    {{ companyInfo.phone.replace(/^(.{3})(.*)(.{4})/, '$1-$2-$3') }}
                  </template>
                  <template v-else>
                    {{ companyInfo.phone }}
                  </template>
                </el-button>
              </el-badge>
            </p>
            <p>&emsp;电子邮箱：
              <el-badge value="修改" type="primary" @click.native="editDelegate">
                <el-button size="" style="border: 0; background-color: transparent; padding: 0px 8px 14px 0;">
                  {{ companyInfo.email }}
                </el-button>
              </el-badge>
            </p>
            <p>&emsp;根据本次集中议价后续工作开展的需要，我们将通过上述联系方式与您联系。</p>
            <p>&emsp;请您确认上述联系方式正确无误，如有问题请及时修改。</p>
            <p>&emsp;为保障您账户安全，请您定期&nbsp;<el-button size="xs" type="primary" style="color: #fff; padding: 2px 5px;" @click.native="editPassword=true">修改密码</el-button></p>
          </el-alert>
        </template>
      </el-tab-pane>
      <el-tab-pane name='1'>
        <template #label>
          <span><i class="el-icon-user-solid"></i>企业信息</span>
        </template>
        <template>
          <el-form @submit.native.prevent style="text-align: left; margin: 15px" label-position="right" label-width="150px" status-icon key="companyInfo" :rules="companyInfoRules" :model="companyInfo" ref="companyInfo">
        <el-row type="flex">
          <el-col :span="24">
            基本信息
            <el-divider></el-divider>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="24">
            <el-alert title="  进口药品全国总代理请填写国内代理企业社会统一社会信用代码，企业信息选择「进口药品全国总代理」为‘是’。" left :closable="false" type="info" show-icon></el-alert>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="12">
            <el-form-item label="企业注册类型"  prop="companyType">
              <el-select v-model="companyInfo.companyType" disabled placeholder="请选择" style="width: 200px">
                <el-option
                  v-for="item in companyTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="进口药品全国总代理/药品上市许可持有人" label-width="280" prop="agent" v-if="companyInfo.companyType === '1'">
              <el-radio-group v-model="companyInfo.agent" disabled>
                <el-radio :label="'1'">是</el-radio>
                <el-radio :label="'0'">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="12">
            <el-form-item label="统一社会信用代码" prop="zzjgdm">
              <el-input v-model="companyInfo.zzjgdm" placeholder="请输入18位统一社会信用代码" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="企业名称"  prop="companyName">
                <el-input v-model="companyInfo.companyName" maxlength="200" placeholder="请输入企业名称" autocomplete="off">
                </el-input>
              </el-form-item>
            </el-col>
            <el-form-item label="法定代表人"  prop="attr_qyfrxm">
              <el-input v-model="companyInfo.attr_qyfrxm" placeholder="同营业执照中的法定代表人" autocomplete="off" style="width: 200px"></el-input>
            </el-form-item>
          </el-row>
          </el-form>
        </template>

        <template>
          <el-form @submit.native.prevent style="text-align: left; margin: 15px" label-position="right" label-width="360px" status-icon key="qyzzUpload" :rules="qyzzUploadRules" :model="qyzzUpload" ref="qyzzUpload">
          <el-row type="flex">
            <el-col :span="24">
              资质证照
              <el-divider></el-divider>
            </el-col>
          </el-row>
          <el-alert title="文件格式仅支持jpg/jpeg/gif/png/bmp/pdf" type="warning" center show-icon></el-alert>
          <el-form-item label="营业执照" prop="yyzzImg">
            <el-upload
              class="upload-left"
              :action="uploadImgUrl"
              :on-preview="handlePreview"
              :before-remove="beforeRemove"
              :on-remove="handleRemoveyyzzImg"
              :multiple="false"
              :limit="1"
              :on-exceed="handleExceed"
              :before-upload="beforeFileUpload"
              :on-success="handleSuccessyyzzImg"
              :on-error="handleError"
              :file-list="fileListyyzzImg"
              >
              <el-button :loading="submitButtonLoading" size="small" type="primary">上传营业执照</el-button>
            </el-upload>
          </el-form-item>
          <template v-if="companyInfo.companyInfo == 1 || companyInfo.companyInfo == 2">
            <el-form-item :label="qyzzUpload.ypscImgName" prop="ypscImg">
              <el-upload
                class="upload-left"
                :action="uploadImgUrl"
                :on-preview="handlePreview"
                :before-remove="beforeRemove"
                :on-remove="handleRemoveypscImg"
                :multiple="false"
                :limit="1"
                :on-exceed="handleExceed"
                :before-upload="beforeFileUpload"
                :on-success="handleSuccessypscImg"
                :on-error="handleError"
                :file-list="fileListypscImg"
              >
                <el-button :loading="submitButtonLoading" size="small" type="primary">{{qyzzUpload.ypscImgName}}</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item label="法定代表人授权证书" prop="fddbrsqzsImg">
              <el-upload
                class="upload-left"
                :action="uploadImgUrl"
                :on-preview="handlePreview"
                :before-remove="beforeRemove"
                :on-remove="handleRemovefddbrsqzsImg"
                :multiple="false"
                :limit="1"
                :on-exceed="handleExceed"
                :before-upload="beforeFileUpload"
                :on-success="handleSuccessfddbrsqzsImg"
                :on-error="handleError"
                :file-list="fileListfddbrsqzsImg"
              >
                <el-button :loading="submitButtonLoading" size="small" type="primary">上传法定代表人授权证书</el-button>
              </el-upload>
            </el-form-item>
          </template>
          <el-row type="flex" v-if="!companyInfo.activation">
            <el-col :span="18">
              <el-form-item label="验证码"  prop="captcha">
                <el-input v-model="qyzzUpload.captcha" placeholder="请输入验证码" autocomplete="off" autocapitalize="off" spellcheck="false"></el-input>
              </el-form-item>
            </el-col>
              <img ref="captcha" style="width: 100px; height: 40px" :src="captchaUrl" @click="changCaptcha" />
          </el-row>
        </el-form>
        <el-row style="text-align: center;" v-if="!companyInfo.activation">
          <el-button :loading="submitButtonLoading" type="primary" style="margin: 20px 0;" @click="submitForm('qyzzUpload')">&emsp;提&emsp;交&emsp;</el-button>
        </el-row>
        </template>
      </el-tab-pane>
      <el-tab-pane name='2'>
        <template #label>
          <span><i class="el-icon-user-solid"></i>业务联系人</span>
        </template>
        <el-row type="flex">
          <el-col :span="24">
            业务联系人信息
            <el-divider></el-divider>
            <el-button plain style="width: 100%" size="mini" @click="addContact">
              <i class="el-icon-plus" /> 新增业务联系人
            </el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-table :data="companyInfo.contacts" border style="width: 100%" size="mini" @cell-mouse-leave="showClickIcon=false">
            <el-table-column fixed="left" type="index" label="序号" width="50" align='center'></el-table-column>
            <el-table-column prop="lxr" label="联系人姓名" width="120" align='center'></el-table-column>
            <el-table-column prop="phone" label="联系电话" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="email" label="电子邮箱" width="130" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="departments" label="所属部门和职务" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="remark" label="备注" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column fixed="right" label="操作" width="60" align='center'>
              <template #default="scope">
                <el-button @click="deleteContact(scope.row)" type="text" size="mini">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    </div>

    <el-dialog title="修改联系人(被授权人)信息" :visible.sync="editLayer">
      <el-form @submit.native.prevent style="text-align: left; margin: 5px" label-position="right" label-width="150px" status-icon key="comdelegatepanyInfo" :rules="delegateRules" :model="delegate" ref="delegate">
        <el-row type="flex">
          <el-col :span="12">
            <el-form-item label="联系人(被授权人)"  prop="attr_lxr">
              <el-input v-model="delegate.attr_lxr" placeholder="请输入一位联系人(被授权人)" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-form-item label="所属部门和职务">
            <el-input v-model="delegate.departments" placeholder="请输入所属部门和职务" autocomplete="off"></el-input>
          </el-form-item>
        </el-row>

        <el-row type="flex">
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idNumber">
              <el-input v-model="delegate.idNumber" placeholder="请输入联系人身份证号" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
            <el-form-item label="联系电话"  prop="phone">
              <el-input v-model="delegate.phone" placeholder="请输入联系电话" autocomplete="off"></el-input>
            </el-form-item>
        </el-row>
        <el-row type="flex">
          <el-col :span="12">
            <el-form-item label="电子邮箱"  prop="email">
              <el-input v-model="delegate.email" placeholder="请输入电子邮箱" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="text-align: center;">
          <el-button :loading="submitButtonLoading" type="primary" @click="submitDelegate('delegate')">&emsp;提&emsp;交&emsp;</el-button>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog title="新增业务联系人" :visible.sync="addLayer" width="500px">
      <el-form @submit.native.prevent style="text-align: left; margin: 5px" label-position="right" label-width="150px" status-icon key="contact" :rules="contactRules" :model="contact" ref="contact">
        <el-row type="flex">
          <el-form-item label="联系人姓名"  prop="attr_lxr">
            <el-input v-model="contact.attr_lxr" placeholder="请输入联系人姓名" autocomplete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex">
          <el-form-item label="联系电话"  prop="attr_phone">
            <el-input v-model="contact.attr_phone" placeholder="请输入联系电话" autocomplete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex">
          <el-form-item label="电子邮箱"  prop="attr_email">
            <el-input v-model="contact.attr_email" placeholder="请输入电子邮箱" autocomplete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex">
          <el-form-item label="所属部门和职务">
            <el-input v-model="contact.attr_departments" placeholder="请输入所属部门和职务" autocomplete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex">
          <el-form-item label="备注" prop="remark">
            <el-input v-model="contact.attr_remark" placeholder="如负责区域、医院等" autocomplete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row style="text-align: center;">
          <el-button :loading="submitButtonLoading" type="primary" @click="submitContact('contact')">&emsp;提&emsp;交&emsp;</el-button>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog title="修改账户密码" :visible.sync="editPassword" >
      <el-form @submit.native.prevent style="width: 550px; margin: 0 auto;" label-position="right" label-width="150px" status-icon key="loginAccount" :rules="loginAccountRules" :model="loginAccount" ref="loginAccount">
        <el-form-item label="原密码" prop="origPwd">
          <el-input v-model="loginAccount.origPwd" placeholder="请输入账户登录密码"  autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input v-model="loginAccount.newPwd" placeholder="请输入6-20位新密码" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input v-model="loginAccount.checkPass" placeholder="请再次输入新密码"  autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-row style="text-align: center;">
          <el-button :loading="submitButtonLoading" type="primary" @click="submitPassword('loginAccount')">&emsp;提&emsp;交&emsp;</el-button>
        </el-row>
      </el-form>

    </el-dialog>
    <el-dialog :visible.sync="dialogImageVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <FooterView></FooterView>
  </div>
</template>
<script>
  export default {
    name: 'user-account',
    data() {
      var checkPass =(rule, value, callback) => {
        if (value !== this.loginAccount.newPwd) {
          callback(new Error(rule.message));
        } else {
          callback();
        }
      };
      var zcxyCheck =(rule, value, callback) => {
        if(!value){
          callback(new Error(rule.message));
        } else {
          callback();
        }
      };
      //统一社会信用代码
      var zzjgdmUnique =(rule, value, callback) => {
        this.submitButtonLoading = true;
        this.$api.registerApi.zzjgdmUnique({'zzjgdm':value}).then(response => {
          this.submitButtonLoading = false;
          if (response.status === 200) {
            if (response.data.code === 200) {
              callback();
            } else {
              callback(new Error(response.data.msg));
            }
          } else {
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      };
      //企业名称
      var companyNameUnique =(rule, value, callback) => {
        this.submitButtonLoading = true;
        this.$api.registerApi.companyNameUnique2({'companyName':value}).then(response => {
          this.submitButtonLoading = false;
          if (response.status === 200) {
            if (response.data.code === 200) {
              callback();
            } else {
              callback(new Error(response.data.msg));
            }
          } else {
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      };
      //验证码
      var captchaUnique =(rule, value, callback) => {
        this.submitButtonLoading = true;
        this.$api.registerApi.captchaValidate({'captcha':value}).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              callback();
            }else{
              callback(new Error(response.data.data));
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      };
      return {
        active: '0',
        height: 0,
        registerInvalid: false,
        submitButtonLoading: false,
        dialogImageVisible: false,
        dialogPdfVisible: false,
        dialogImageUrl: '',
        dialogPdfUrl: null,
        pdfPage : 1,
        pageCount: 0,
        captchaUrl: '',
        zcxyUrl: '', //注册协议
        uploadImgUrl: '', //图片上传
        addLayer: false,
        editLayer: false,
        editPassword: false,
        companyTypes: [
          {
            value: '1',
            label:'生产企业'
          },
          {
            value: '2',
            label:'经营企业'
          },
          {
            value: '3',
            label:'疫苗生产企业'
          },
          {
            value: '4',
            label:'疫苗仓储配送企业'
          }
        ],
        loginAccount: {
          origPwd: '',//原密码
          newPwd: '', //新密码
          checkPass: '' //确认密码
        },
        delegate: {
          id: '',
          attr_lxr: '', //联系人(被授权人)
          departments: '', //所属部门和职务
          idNumber: '', //身份证号
          phone: '', //联系电话
          email: '' //电子邮箱
        },
        contact: {
          id: '',
          attr_lxr: '', //联系人(被授权人)
          attr_departments: '', //所属部门和职务
          attr_phone: '', //联系电话
          attr_email: '', //电子邮箱
          attr_remark: ''
        },
        companyContact: {},
        companyInfo: {
          id: '',
          activation: true,
          error: '',
          username: '', //账户名
          zzjgdm: '', //统一社会信用代码
          companyType: '', //企业注册类型
          attr_shortName: '', //企业简称
          agent: undefined, //是否进口药品全国总代理
          companyName: '', //企业名称
          attr_qyfrxm: '', //法定代表人
          attr_lxr: '', //联系人(被授权人)
          departments: '', //所属部门和职务
          idNumber: '', //身份证号
          phone: '', //联系电话
          email: '', //电子邮箱
          contacts: []
        },
        qyzzUpload: {
          yyzzImg: '', //营业执照
          ypscImg: '', //药品生产许可证 / 进口药品全国总代理 协议
          ypscImgName: '', //根据agent变化药品生产许可证 / 进口药品全国总代理 协议
          ypjyImg: '',
          fddbrsqzsImg: '', //法定代表人授权证书
          captcha: '', //验证码
          zcxy: true //注册协议
        },
        fileListyyzzImg:[],
        fileListypscImg:[],
        fileListfddbrsqzsImg:[],
        loginAccountRules: {
          origPwd: [//远程校验唯一
            { required: true, message: '请输入账户登录密码！', trigger: 'blur' },
            { min: 6, max: 20, message: '请输入6-20位密码！', trigger: 'blur' },
          ],
          newPwd: [
            { required: true, message: '请输入6-20位密码', trigger: 'blur' },
            { min: 6, max: 20, message: '请输入6-20位密码', trigger: 'blur' },
            { pattern: /(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).{6,20}/, message: '密码中必须包含大小写字母、数字', trigger: 'blur' },

          ],
          checkPass: [
            { required: true, message: '请再次输入密码', trigger: 'blur' },
            { min: 6, max: 20, message: '请输入6-20位密码', trigger: 'blur' },
            { validator:checkPass, message: '两次输入密码不一致!', trigger: 'blur' }
          ]
        },
        companyInfoRules: {
          zzjgdm: [ //远程校验唯一
            { required: true, message: '请输入18位统一社会信用代码', trigger: 'blur' },
            { min: 18, max: 18, message: '请输入18位统一社会信用代码', trigger: 'blur' },
            //{ validator:zzjgdmUnique, message: '统一社会信用代码已注册', trigger: 'blur' }
          ],
          companyType: [
            { required: true, message: '请选择企业注册类型', trigger: 'blur' }
          ],
          companyName: [
            { required: true, message: '请输入企业名称', trigger: 'blur' },
            { min: 0, max: 200, message: '最大200个汉字', trigger: 'blur' },
            //{ validator:companyNameUnique, message: '企业名称已注册', trigger: 'blur' }
          ],
          agent: [
            { required: true, message: '请选择', trigger: 'blur' }
          ],
          attr_qyfrxm: [
            { required: true, message: '请输入法定代表人', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255个汉字', trigger: 'blur' }
          ],
          attr_lxr: [
            { required: true, message: '请输入一位联系人(被授权人)', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255个汉字', trigger: 'blur' }
          ],
          idNumber: [
            { required: true, message: '请输入联系人身份证号', trigger: 'blur' },
            { min: 0, max: 18, message: '最大18位', trigger: 'blur' },
            {
              pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
              message: "请输入正确的身份证号"
            }
          ],
          phone: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255位', trigger: 'blur' },
            {
              pattern: /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/,
              message: "请输入正确的联系电话"
            }
          ],
          email: [
            { required: true, message: '请输入电子邮箱', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255位', trigger: 'blur' },
            {
              pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
              message: "请输入正确的电子邮箱"
            }
          ],
        },
        delegateRules: {
          attr_lxr: [
            { required: true, message: '请输入一位联系人(被授权人)', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255个汉字', trigger: 'blur' }
          ],
          idNumber: [
            { required: true, message: '请输入联系人身份证号', trigger: 'blur' },
            { min: 0, max: 18, message: '最大18位', trigger: 'blur' },
            {
              pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
              message: "请输入正确的身份证号"
            }
          ],
          phone: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255位', trigger: 'blur' },
            {
              pattern: /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/,
              message: "请输入正确的联系电话"
            }
          ],
          email: [
            { required: true, message: '请输入电子邮箱', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255位', trigger: 'blur' },
            {
              pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
              message: "请输入正确的电子邮箱"
            }
          ],
        },
        contactRules: {
          attr_lxr: [
            { required: true, message: '请输入联系人姓名', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255个汉字', trigger: 'blur' }
          ],
          attr_phone: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255位', trigger: 'blur' },
            {
              pattern: /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/,
              message: "请输入正确的联系电话"
            }
          ],
          attr_email: [
            { required: true, message: '请输入电子邮箱', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255位', trigger: 'blur' },
            {
              pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
              message: "请输入正确的电子邮箱"
            }
          ],
        },
        qyzzUploadRules: {
          yyzzImg: [
            { required: true, message: '请上传营业执照', trigger: 'blur' }
          ],
          fddbrsqzsImg: [
            { required: true, message: '请上传法定代表人授权证书', trigger: 'blur' }
          ],
          captcha: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ]
        }
      };
    },
    mounted(){
      //动态设置内容高度 让footer始终居底   header+footer的高度是100
      this.height = document.documentElement.clientHeight - 350;
      //监听浏览器窗口变化　
      window.onresize = ()=> {this.height = document.documentElement.clientHeight - 350}
    },
    created() {
      this.captchaUrl = this.getCaptchaUrl();
      this.zcxyUrl = process.env.VUE_APP_API_URL + 'member/register_agreement.jspx';
      this.uploadImgUrl = process.env.VUE_APP_API_URL + 'member/o_upload_image2.jspx';
      this.initView();
    },
    watch:{
      companyInfo: {
        handler(val, oldVal){
          if('1' === val.companyType){
            this.qyzzUpload.ypscImgName = val.agent === '0' ? '药品生产许可证':'进口药品全国总代理协议/药品上市许可持有人资质证明';
          }else if('2' === val.companyType){
            this.qyzzUpload.ypscImgName = '药品经营许可证';
          }
          let qyzzUploadRulesTemp = {
            ypscImg: [
              { required: true, message: "请上传"+this.qyzzUpload.ypscImgName, trigger: 'blur' }
            ]
          };
          Object.assign(this.qyzzUploadRules, qyzzUploadRulesTemp);
        },
        deep:true //true 深度监听
      }
    },
    methods: {
      initView(){
        setTimeout(() => {
          this.submitButtonLoading = true;
          new Promise((resolve, reject) =>{
            return this.$api.memberApi.getAccount({}).then(data => {
              this.submitButtonLoading = false;
              if(200 === data.status){
                if(200 === data.data.code){
                  if(!!data.data.data.companyInfo){
                    this.companyInfo = JSON.parse(data.data.data.companyInfo);
                  }
                  if(!!data.data.data.contacts){
                    this.companyInfo.contacts = JSON.parse(data.data.data.contacts);
                  }
                  if(!!data.data.data.qyzzUpload){
                    this.qyzzUpload = JSON.parse(data.data.data.qyzzUpload);
                    this.fileListyyzzImg = [];
                    this.fileListypscImg = [];
                    this.fileListfddbrsqzsImg = [];
                    if(!!this.qyzzUpload.yyzzImg){
                      this.fileListyyzzImg.push({ name: '企业营业执照', url: this.qyzzUpload.yyzzImg, response: {data: this.qyzzUpload.yyzzImg}})
                    }
                    if(!!this.qyzzUpload.ypscImg){
                      this.fileListypscImg.push({ name: '企业资质证明', url: this.qyzzUpload.ypscImg, response: {data: this.qyzzUpload.ypscImg}})
                    }
                    if(!!this.qyzzUpload.fddbrsqzsImg){
                      this.fileListfddbrsqzsImg.push({ name: '法定代表人授权证书', url: this.qyzzUpload.fddbrsqzsImg, response: {data: this.qyzzUpload.fddbrsqzsImg}});
                    }
                  }
                  resolve(true);
                }else if(403 === data.data.code){
                  this.goLogin(response.data.msg);
                }else{
                  this.$message({ message: data.data.data, offset: 200, type: 'error' });
                }
              }
              resolve(false);
            })
          }).then(res =>{
          }).catch(err => {
            console.info(err);
          })
        }, 200)
      },
      changCaptcha: function() {
        this.captchaUrl = this.getCaptchaUrl();
      },
      getCaptchaUrl: function() {
        this.qyzzUpload.captcha = '';
        return process.env.VUE_APP_API_URL+'captcha.svl?d='+new Date().getTime()
      },
      previous() {
        //console.log(this.fileListyyzzImg, this.loginAccount, this.companyInfo, this.qyzzUpload);
        if (this.active-- < 0) this.active = 0;
      },
      editDelegate() {
        Object.keys(this.delegate).forEach(key=> { this.delegate[key] = this.companyInfo[key] })
        this.editLayer = true;
      },
      next(formName, value) {
        this.submitButtonLoading = true;
        if(formName){
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.submitButtonLoading =  false;
              this.active = value;
            } else {
              this.submitButtonLoading =  false;
              return false;
            }
          });
        }else{
          this.submitButtonLoading = false;
          this.active = value;
        }
      },
      submitContact(formName) {
        this.$refs[formName].validate((valid) => {
          if(valid){
            this.submitButtonLoading = true;
            var objson = {};
            Object.assign(objson, { ...this.contact });
            this.$api.memberApi.submitContact(objson).then(response => {
              this.submitButtonLoading = false;
              if(response.status === 200){
                if(response.data.code === 200){
                  this.addLayer = false;
                  this.$message({ message: response.data.data, offset: 200, type: 'success' });
                  this.initView();
                }else{
                  this.$message.error({message:response.data.msg || `服务忙，请稍后再试`});
                }
              }else{
                this.$message.error({message:response.data.msg || `服务忙，请稍后再试`});
              }
            }).catch(error => {
              this.submitButtonLoading = false;
            });
          }
        })
      },
      submitDelegate(formName) {
        this.$refs[formName].validate((valid) => {
          if(valid){
            this.submitButtonLoading = true;
            var objson = {};
            Object.assign(objson, { ...this.delegate });
            this.$api.memberApi.updateDelegate(objson).then(response => {
              this.submitButtonLoading = false;
              if(response.status === 200){
                if(response.data.code === 200){
                  this.editLayer = false;
                  this.$message({ message: response.data.data, offset: 200, type: 'success' });
                  this.initView();
                }else{
                  this.$message.error({message:response.data.msg || `服务忙，请稍后再试`});
                }
              }else{
                this.$message.error({message:response.data.msg || `服务忙，请稍后再试`});
              }
            }).catch(error => {
              this.submitButtonLoading = false;
            });
          }
        })
      },
      submitPassword(formName) {
        this.$refs[formName].validate((valid) => {
          if(valid){
            //origPwd, String newPwd, String email, String nextUrl
            let { email } = { ...this.companyInfo };
            let { origPwd, newPwd } = {...this.loginAccount};

            this.submitButtonLoading = true;
            var objson = {};
            Object.assign(objson, { origPwd, newPwd, email });
            this.$api.memberApi.updatePassword(objson).then(response => {
              this.submitButtonLoading = false;
              if(response.status === 200){
                if(response.data.code === 200){
                  const data = response.data.data;
                  if(0 === data.code){
                    this.$message({ message: data.msg, offset: 200, type: 'success' });
                    this.goLogin();
                  }else{
                    this.$message({ message: data.msg, offset: 200, type: 'error' });
                  }
                }else{
                  this.$message.error({message:response.data.data.msg || `服务忙，请稍后再试`});
                }
              }else{
                this.$message.error({message:response.data.msg || `服务忙，请稍后再试`});
              }
            }).catch(error => {
              this.submitButtonLoading = false;
            });
          }
        });
      },
      submitForm(formName) {
        let _valid = false;
        this.$refs['companyInfo'].validate((valid) => {
          _valid = valid;
        });
        if(!_valid){
          return false;
        }
        this.$refs[formName].validate((valid) => {
          _valid = valid;
        });
        if(!_valid){
          return false;
        }

        let {id, zzjgdm, companyName, attr_qyfrxm} = {...this.companyInfo};
        if(!id){
          this.$message.error({message: `用户信息不存在，请刷新后重试！`});
          return false;
        }

        this.submitButtonLoading = true;
        var json3 = {};
        Object.assign(json3, this.qyzzUpload, {id, zzjgdm, companyName, attr_qyfrxm});
        this.$api.memberApi.updateTalent(json3).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              this.$message({ message: response.data.data, offset: 200, type: 'success' });
              this.initView();
            }else{
              this.captchaUrl = this.getCaptchaUrl();
              this.$message.error({message:response.data.msg || `服务忙，请稍后再试`});
            }
          }else{
            this.captchaUrl = this.getCaptchaUrl();
            this.$message.error({message:response.data.msg || `服务忙，请稍后再试`});
          }
        }).catch(error => {
          this.captchaUrl = this.getCaptchaUrl();
          this.submitButtonLoading = false;
        });
      },
      addContact(){
        this.contact.id = '';
        this.contact.attr_lxr = ''; //联系人(被授权人)
        this.contact.attr_departments = ''; //所属部门和职务
        this.contact.attr_phone = ''; //联系电话
        this.contact.attr_email = ''; //电子邮箱
        this.contact.attr_remark = '';
        this.addLayer = true;
      },
      deleteContact(w) {
        this.$confirm(`确定删除联系人「 ${ w.lxr }」？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var objson = {};
          Object.assign(objson, { ...w });
          this.$api.memberApi.deleteContact(objson).then(response => {
            this.submitButtonLoading = false;
            if(response.status === 200){
              if(response.data.code === 200){
                this.$message({ message: response.data.data, offset: 200, type: 'success' });
                this.initView();
              }else{
                this.$message.error({message:response.data.msg || `服务忙，请稍后再试`});
              }
            }else{
              this.$message.error({message:response.data.msg || `服务忙，请稍后再试`});
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        }).catch(() => {
        });
      },
      goLogin(msg) {
        if(msg){
          this.$message({ message: `登录过期，请重新登录账户！`, offset: 200, type: 'error' });
        }
        setTimeout(() => {
          this.submitButtonLoading = false;
          window.location.href = process.env.VUE_APP_API_URL;
        }, 1500)
      },
      handleRemoveyyzzImg(file, fileList) {
        console.log(file, fileList);
        this.qyzzUpload.yyzzImg = '';
        this.fileListyyzzImg = fileList.slice(0,0);
      },
      handleRemoveypscImg(file, fileList) {
        console.log(file, fileList);
        this.qyzzUpload.ypscImg = '';
        this.fileListypscImg = fileList.slice(0,0);
      },
      handleRemovefddbrsqzsImg(file, fileList) {
        console.log(file, fileList);
        this.qyzzUpload.fddbrsqzsImg = '';
        this.fileListfddbrsqzsImg = fileList.slice(0,0);
      },
      handlePreview(file) {
        console.log("handlePreview",file);
        let fileUrl = process.env.VUE_APP_BASE_URL + '/member/readflie.jspx?filePath=' + file.response.data;
        if (!fileUrl.endsWith('.pdf')) {
          this.dialogImageUrl = fileUrl;
          this.dialogImageVisible = true;
        } else {
          this.dialogPdfUrl = fileUrl;
          window.open(fileUrl);
        }
      },
      handleExceed(files, fileList) {
        this.$message.error(`当前限制上传 1 个文件`);
      },
      beforeFileUpload(file) {
        const supportFileType = ["jpg", "jpeg", "gif", "png", "bmp","pdf"];

        let type1 = (file.name).substring((file.name).lastIndexOf(".")+1);
        let fileExt = type1.trim().toLowerCase();

        const isSupport = supportFileType.indexOf(fileExt)>-1;
        const isLt100M = file.size / 1024 / 1024 < 100;

        if (!isSupport) {
          this.$message.error('只能上传['+supportFileType+']格式的文件!');
        }
        if (!isLt100M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }
        return isSupport && isLt100M;
      },
      handleSuccessyyzzImg(response, file, fileList) {
        if(response.code === 200){
          this.qyzzUpload.yyzzImg = response.data;
          this.fileListyyzzImg = fileList;
        }else{
          this.$message.error(response.msg);
          this.fileListyyzzImg = fileList.slice(0,0);
        }
      },
      handleSuccessypscImg(response, file, fileList) {
        if (response.code === 200) {
          this.qyzzUpload.ypscImg = response.data;
          this.fileListypscImg = fileList;
        } else {
          this.$message.error(response.msg);
          this.fileListypscImg = fileList.slice(0,0);
        }
      },
      handleSuccessfddbrsqzsImg(response, file, fileList) {
        if (response.code === 200) {
          this.qyzzUpload.fddbrsqzsImg = response.data;
          this.fileListfddbrsqzsImg = fileList;
        } else {
          this.$message.error(response.msg);
          this.fileListfddbrsqzsImg = fileList.slice(0,0);
        }
      },
      handleError(response, file, fileList) {
        this.$message.error(`上传失败，请稍后再试`);
      },
      beforeRemove(file, fileList) {
        console.log(file);
        if(file.status !== 'ready')
          return this.$confirm(`确定移除 ${ file.name }？`);
      },
      //关闭窗口初始化PDF页码
      closePdfDialog(){
        this.pdfPage = 1;
        this.dialogPdfVisible = false;
      },
      //PDF改变页数
      previousPdfPage(){
        var p = this.pdfPage
        p = p>1?p-1:this.pageCount
        this.pdfPage = p
      },
      nextPdfPage(){
        var p = this.pdfPage
        p = p<this.pageCount?p+1:1
        this.pdfPage = p
      },
    }
  }
</script>
<style>
  .el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
  }
  .account-title {
    padding: 20px 15px;
  }
  .account-title p {
      line-height: 36px;
      font-size: 16px;

  }
  .upload-left{
    text-align: left;
  }
  .register-wrapper-div{
    text-align: center;
    padding-top:10px;
    width: 850px;
    margin: 0 auto;
    background-color: #f8f8f8;
  }
  .el-alert .el-alert__description{
    line-height: 24px;
  }

  .el-badge__content.is-fixed {
    top: 5;
    right: 10;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/Member/MyAccount.vue